import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=5cd0bf5e&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=ts"
export * from "./PlanDetail.vue?vue&type=script&lang=ts"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=5cd0bf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0bf5e",
  null
  
)

export default component.exports